export default {"src":"/_next/static/media/White.59f23ee4.svg","height":155,"width":462};